import { render, staticRenderFns } from "./editRoleTasks.vue?vue&type=template&id=30ca9516&"
import script from "./editRoleTasks.vue?vue&type=script&lang=js&"
export * from "./editRoleTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports